import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { UserService } from '../../../../shared/services/user.service';
import { ManageEquipmentService } from '../../manage-equipment.service';
import { Subscription } from 'rxjs/Subscription';
import { CustomerSelectItem, JobsiteSelectItem } from '../../../setup-equipment/setup-equipment.model';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../../shared/services/loading.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-jobsite',
  templateUrl: './change-jobsite.component.html',
  styleUrls: ['./change-jobsite.component.scss']
})
export class ChangeJobsiteComponent implements OnInit {
  private _subscriptions: Subscription[] = [];
  private _equipmentId: number;
  customerList: CustomerSelectItem[] = [];
  jobsiteList: JobsiteSelectItem[] = [];
  selectedCustomer: number;
  selectedJobsite: number;
  saving: boolean = false;

  constructor(private _user: UserService,
    private _equipment: ManageEquipmentService,
    public dialogRef: MatDialogRef<ChangeJobsiteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService,
    private _loading: LoadingService) { }

  ngOnInit() {
      this._loading.startLoading();
      this._subscriptions.push(this._user.getCustomerList().subscribe(customers => { this.customerList = customers; this.selectedCustomer = this.data.customerId; this.loadJobsitesForCustomer(); this._loading.finishedLoading(); }));
    this._equipmentId = this.data.equipmentId;
  }

  updateJobsiteClicked() {
    if (this.selectedJobsite == null)
      return;
    this.saving = true;
    this._loading.startLoading();
    this._subscriptions.push(this._equipment.changeEquipmentJobsite(this._equipmentId, this.selectedJobsite).subscribe(succeeded => {
        this.saving = false;
        this._loading.finishedLoading();
      if (succeeded.m_Item1) {
          this._notification.success('Jobsite Changed', 'This equipment has been successfully moved to the jobsite ' + succeeded.m_Item2 + '.');
          this.dialogRef.close(succeeded.m_Item2);
      } else {
        console.log(succeeded.m_Item2);
        this._notification.error('Error', 'Unable to update this equipments jobsite. Please contact TrackTreads support. ');
      }
    }));
  }

  loadJobsitesForCustomer() {
    if (this.selectedCustomer == null)
          return;
    this._loading.startLoading();
    this.selectedJobsite = null;
    this.jobsiteList = [];
    this._subscriptions.push(this._user.getJobsiteList(this.selectedCustomer).subscribe(jobsites => {
        this.jobsiteList = jobsites;
        this._loading.finishedLoading();
    }));
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => {
      if (!s.closed)
        s.unsubscribe();
    });
  }

  onNoClick(): void {
    this.dialogRef.close('New Site Name');
  }
}
